import React from "react";
import { CheckCircle, Globe, Heart } from "lucide-react";
import FeatureCard from "./message/FeatureCard";
import MessageHeader from "./message/MessageHeader";
import WhyChooseSection from "./message/WhyChooseSection";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const MessageSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.sellCar?.messageSection || {};
  const featuresData = sectionData.features || [];

  const icons = [
    <CheckCircle className="w-12 h-12 text-amber-400" />,
    <Globe className="w-12 h-12 text-rose-400" />,
    <Heart className="w-12 h-12 text-emerald-400" />,
  ];
  const gradients = [
    "from-amber-900/30 via-orange-800/20 to-yellow-700/30",
    "from-rose-900/30 via-pink-800/20 to-red-700/30",
    "from-emerald-900/30 via-teal-800/20 to-green-700/30",
  ];

  const features = featuresData.map((feature: any, index: number) => ({
    icon: icons[index] || icons[0],
    title: feature.title || "",
    description: feature.description || "",
    gradient: gradients[index] || gradients[0],
  }));

  return (
    <section className="py-20 bg-gradient-to-b from-black via-gray-900 to-white">
      <div className="container mx-auto px-4">
        <MessageHeader />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 max-w-5xl mx-auto">
          {features.map((item, index) => (
            <FeatureCard key={index} item={item} index={index} />
          ))}
        </div>

        <WhyChooseSection />
      </div>
    </section>
  );
};

export default MessageSection;
